import * as React from "react";
import { Button, cn, type ButtonProps } from "@wa/ui";

/**
 * One whole list row as a single button.
 *
 * The kit's ghost `Button` with the shape of a row instead of a pill: full
 * width, as tall as its content, text on the left. A row that opens a document
 * has to be one target - on a phone a 60-pixel-wide invoice number is not
 * something a thumb can be asked to hit - and it has to be a real button, so
 * the keyboard reaches it and a screen reader announces it.
 *
 * The focus ring is drawn inset and at full strength: rows sit inside a card
 * that clips its corners, and the kit's outer 40% ring would be cut off by it.
 */
export const RowButton = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, ...props }, ref) => (
    <Button
      ref={ref}
      variant="ghost"
      className={cn(
        "h-auto w-full justify-start whitespace-normal rounded-none px-5 py-4 text-left text-sm font-normal",
        "active:scale-100 focus-visible:ring-inset focus-visible:ring-ring",
        className,
      )}
      {...props}
    />
  ),
);
RowButton.displayName = "RowButton";
